<template>
  <AddToCartOverlay
    v-if="productResponse && selectedOffer && selectedOffer.offerLegacyId"
    :items="[
      // Current product page item
      {
        listingId: selectedOffer.offerLegacyId,
        image: productResponse.images[0].url,
        title: productResponse.titles.raw,
        quantity: 1,
      },
      // If user added a bundle to cart
      ...(additionalProduct
        ? [
            {
              listingId: parseInt(additionalProduct.listingId, 10),
              image: additionalProduct.image,
              title: `${additionalProduct.title} ${additionalProduct.description}`,
              quantity: 1,
            },
          ]
        : []),
    ]"
    :opened="shouldShowAddToCartOverlay"
    :trade-in="buybackOffer?.product.fullTitle ?? null"
    @close="handleClose"
  />
</template>

<script setup lang="ts">
import { onBeforeUnmount } from 'vue'

import { useBuybackOffer } from '@backmarket/nuxt-layer-buyback/composables/buybackOffer/useBuybackOffer'

import AddToCartOverlay from '~/scopes/checkout/components/AddToCartOverlay/AddToCartOverlay.vue'
import { useAddToCartOverlay } from '~/scopes/product-core/composables/stores/useAddToCartOverlay/useAddToCartOverlay'
import { useAdditionalProduct } from '~/scopes/product-core/composables/stores/useAdditionalProduct/useAdditionalProduct'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()

const { additionalProduct, clearAdditionalProduct } = useAdditionalProduct()
const { buybackOffer } = useBuybackOffer()

const { shouldShowAddToCartOverlay, closeAddToCartOverlay } =
  useAddToCartOverlay()

function handleClose() {
  closeAddToCartOverlay()
}

onBeforeUnmount(() => {
  closeAddToCartOverlay()
  clearAdditionalProduct()
})
</script>
